
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function DeityIndex() {
  return (
    <NonFSIndex
      data_type="deity"
    />
  );
}
